module.exports = __webpack_public_path__ + "static/media/assurance-program-badge.05d2b039.svg";